import { render } from "./ProductFormComments.vue?vue&type=template&id=2bcfe85c&scoped=true"
import script from "./ProductFormComments.vue?vue&type=script&lang=js"
export * from "./ProductFormComments.vue?vue&type=script&lang=js"

import "./ProductFormComments.vue?vue&type=style&index=0&id=2bcfe85c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bcfe85c"]])

export default __exports__